import type { IAgentTool } from '../IAgentTool';

export const badgeTool: IAgentTool = {
  name: 'badge',
  description: 'Add a badge display rule, optionally tied to a field.',
  parameters: {
    type: 'object',
    properties: {
      field: { type: 'string', description: 'Field to show as badge text' },
    },
  },
  supportedDiagramTypes: [],
  tier: 'visual',
  category: 'display',

  async execute(params, context) {
    const field = typeof params.field === 'string' ? params.field.trim() : '';
    const ruleId = context.stores.viewRules.addViewRule('badge', field ? { name: `Badge: ${field}` } : undefined);

    if (field && ruleId) {
      context.stores.viewRules.updateRuleDisplay(ruleId, {
        badge: {
          icon: 'Tag',
          color: '#0ea5e9',
          position: 'top-right',
          tooltip: field,
        },
      });
    }

    return {
      success: true,
      summary: field ? `Added badge for ${field}.` : 'Added badge rule.',
      createdResourceIds: ruleId ? [ruleId] : [],
    };
  },
};
